<template>
  <Header />

  <div class="section container">
    <div class="content">
      <div v-if="message" style="height: 50vh; display: grid; align-items: center; text-align: center">
        <b>{{ message }}</b>
      </div>

      <div v-if="message === null">
        <div class="heading">
          <h1>Verify Your Information</h1>
        </div>

        <CustomerSizing
          :tops="customer.tops"
          :bottoms="customer.bottoms"
          :fitted-hats="customer.fitted_hats"
          :footwear="customer.footwear"
          :accessories="customer.accessories"

          button-text="Update"
          @sizingFormSubmitted="updateCustomerSizing"
          v-if="customer.id"
        />

        <ul class="form-pagination">
          <li class="form-pagination__item" />
          <li class="form-pagination__item form-pagination__item--active" />
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../api'

import Header from '../components/Header.vue';
import CustomerSizing from '../components/CustomerSizing.vue';

export default {
  name: 'VerifyCustomerSizing',
  components: {
    Header, CustomerSizing
  },
  data() {
    return {
      verificationToken: this.$route.params.verification_token,
      message: null,
      customer: {}
    }
  },
  methods: {
    updateCustomerSizing(sizingAttributes, form) {
      const submitButton = form.elements.submit;
      submitButton.disabled = true;

      api.verifyCustomer(this.verificationToken, sizingAttributes).then(customer => {
        this.customer = customer;
        this.message = "Settings saved successfully!"
      }).catch(errors => {
        console.error(errors)
      }).finally(() => {
        submitButton.disabled = false
      })
    }
  },
  mounted() {
    api.getCustomerWithVerificationToken(this.verificationToken).then(customer => {
      this.customer = customer;
    });
  }
}
</script>
